import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import AuthPageShell from './AuthPageShell';
import LoginForm from './parts/LoginForm';

function getSafeCallbackUrl(raw: string | null): string {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//')) return '/dashboard';
  const pathOnly = raw.split(/[?#]/)[0] ?? raw;
  if (['/signin', '/signup', '/login', '/worker-invite'].some((p) => pathOnly === p || pathOnly.startsWith(`${p}/`))) {
    return '/dashboard';
  }
  return raw;
}

const SignInPage: React.FC = () => {
  const { currentUser, tenantData, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const callbackUrl = getSafeCallbackUrl(searchParams.get('callbackUrl'));
  const isProvisioned = Boolean(tenantData);

  if (loading) {
    return (
      <AuthPageShell>
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600" />
        </div>
      </AuthPageShell>
    );
  }

  if (currentUser) {
    if (isProvisioned) {
      return <Navigate to={callbackUrl} replace />;
    }
    return <Navigate to="/pricing" replace />;
  }

  return (
    <AuthPageShell>
      <LoginForm />
    </AuthPageShell>
  );
};

export default SignInPage;
